import { EventEmitter } from 'events';
import moment from 'moment';

export default class AuthService extends EventEmitter {
  isAuthenticated = (hardCheck) => {
    const accessToken = localStorage.getItem('accessToken');
    if (accessToken) {
      return this.validateAccessToken(accessToken, hardCheck);
    } else {
      return false;
    }
  }

  validateAccessToken = (accessToken, hardCheck) => {
    // refresh accessToken based on refreshToken
    // TODO: use a boolean in cookie to validate accessToken.
    // TODO: check for the expiry datetime for accessToken and update the boolean accordingly.
    if (!hardCheck) { return true; }
    const tokenExpiryDate = localStorage.getItem('accessTokenExpiryDate');
    if (tokenExpiryDate) {
      return moment() <= moment(tokenExpiryDate);
    }
    return false;
  }
}
